import AppConstants from '../config/app.constants';

let LocationDistanceService = ($http, $q) => {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/location-distance`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data;
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/location-distance/create`, { data })
            .then((res) => {
                return res.data;
            })
    };

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/location-distance/${id}/update`, { data })
            .then((res) => {
                return res.data;
            })
    };

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/location-distance/${id}`)
            .then((res) => {
                return res.data;
            })
    }

    return {
        all,
        create,
        update,
        get
    };
};

LocationDistanceService.$inject = ['$http', '$q'];

export default LocationDistanceService;


// WEBPACK FOOTER //
// ./client/app/services/location-distance.service.js